<template>
  <!--  drivers-->
  <div class="driverMain">
    <div class="tasksTop" v-if="isShowSearchBox">
      <div class="topSeach">
        <div style="display: flex; flex-direction: row;">
          <div class="innerSearch">
            <el-input placeholder="SearchName..." v-model="nameInput" class="input-with-select" id="topInput">
              <div slot="prefix">Drivers:</div>
            </el-input>
          </div>

          <div class="innerSearch ex">
            <el-select v-model="tagInput" placeholder="All">
              <el-option v-for="item in tagsOptions" :key="item.id" :label="item.tag_name" :value="item.id">
              </el-option>
              <div slot="prefix">Driver type:</div>
              <div style="clear: both"></div>
            </el-select>
          </div>

          <div class="innerSearch">
            <el-select v-model="groupInput" placeholder="All">
              <el-option v-for="item in groupOption" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
              <div slot="prefix">Group:</div>
              <div style="clear: both"></div>
            </el-select>
          </div>

          <div class="innerSearch">
            <el-input placeholder="Search..." v-model="codeInput" class="input-with-select" id="topInput">
              <div slot="prefix">Code:</div>
            </el-input>
          </div>
        </div>

        <div class="innerSearch" style="padding-left: 128px;width: 100%;text-align: right;">
          <el-button type="warning" style="background: #ffc215; border: 1px solid #ffc215 !important" round
            @click="onclickDownloadPDF">Download Barcodes</el-button>

          <el-button type="success" round @click="getDriversListDataSearch"
            style="width: 80px; padding: 0">Search</el-button>
          <el-button plain @click="clearAll" style="width: 80px" class="changeFocus">Clear</el-button>
        </div>
      </div>
    </div>

    <div class="topBton" style="margin-top: 24px">
      <div class="innerLeft">
        <el-tabs v-model="activeNames" stretch @tab-click="changeShowNew">
          <el-tab-pane label="Drivers" name="first">
            <div class="tabel" v-loading="driverLoading">
              <el-table :data="driverData" style="width: 100%; font-weight: normal" v-if="driverData.length != 0">
                <el-table-column header-align="left" align="left" prop="name" label="Driver’s name" width="250px"
                  class-name="changePadding">
                </el-table-column>
                <el-table-column prop="tag_name" label="Driver type"></el-table-column>
                <el-table-column prop="code" label="Driver code"></el-table-column>
                <el-table-column prop="group_name" label="Group">
                </el-table-column>
                <el-table-column label="Status">
                  <template slot-scope="scope">
                    <div :style="scope.row.is_active == 1
                        ? { color: '#82D237' }
                        : { color: '#E95646' }
                      " style="font-weight: bold">
                      {{ scope.row.active_name }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="Actions" width="180px">
                  <template slot-scope="scope">
                    <div class="action">
                      <span @click="handleEdit(scope.$index, scope.row)">
                        <img src="../assets/image/edit@2x.png" alt="" />
                      </span>
                      <span @click="handleDelete(scope.$index, scope.row)">
                        <img src="../assets/image/delete@2x.png" alt="" />
                      </span>
                      <span @click="
                        resetDialog = true;
                      reset_driver = scope.row.id;
                      ">
                        <img src="../assets/reset.png" alt="" />
                      </span>
                      <span v-if="scope.row.is_active == 0" @click="activeAccount(scope.row)">
                        <img src="../assets/add.png" alt="" />
                      </span>
                      <span v-else @click="activeAccount(scope.row)">
                        <img src="../assets/cancel.png" alt="" />
                      </span>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <div v-else class="empty">
                <div>
                  <img src="../assets/image/list_blank.png" alt="" />
                  <h2 style="color: #cccccc; font-size: 16px">
                    No items found
                  </h2>
                  <el-button type="primary" round style="margin-right: 16px" @click="addNew">NEW</el-button>
                </div>
              </div>
            </div>
            <div class="btomPagin">
              <div class="innerLefts">
                {{ page }} - <span>{{ driverData.length }}</span> of
                <span>{{ total }}</span> items
              </div>
              <div>
                <el-pagination :page-size="10" layout="prev, pager, next, jumper" :total="total"
                  @current-change="handleSizeChange">
                </el-pagination>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="Groups" name="second">
            <div class="tabel" v-loading="groupLoading">
              <el-table :data="groupData" style="width: 100%; font-weight: normal" v-if="total1 != 0">
                <el-table-column header-align="center" align="center" prop="name" label="Driver group name" width="250px">
                </el-table-column>
                <el-table-column prop="driver_name" label="Drivers" show-overflow-tooltip>
                </el-table-column>
                <el-table-column label="Actions" width="130px">
                  <template slot-scope="scope">
                    <div class="action">
                      <span @click="handleEdit(scope.$index, scope.row)">
                        <img src="../assets/image/edit@2x.png" alt="" />
                      </span>
                      <span @click="handleDelete(scope.$index, scope.row)">
                        <img src="../assets/image/delete@2x.png" alt="" />
                      </span>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <div v-else class="empty">
                <div>
                  <img src="../assets/image/list_blank.png" alt="" />
                  <h2 style="color: #cccccc; font-size: 16px">
                    No items found
                  </h2>
                  <el-button type="primary" round style="margin-right: 16px" @click="addNew">NEW</el-button>
                </div>
              </div>
            </div>
            <div class="btomPagin">
              <div class="innerLefts">
                {{ page1 }} - <span>{{ groupData.length }}</span> of
                <span>{{ total1 }}</span> items
              </div>
              <div>
                <el-pagination :page-size="10" layout="prev, pager, next, jumper" :total="total1"
                  @current-change="handleSizeChange1">
                </el-pagination>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="Driver type" name="third">
            <div class="tabel" v-loading="groupTagsLoading">
              <el-table :data="TagsData" style="width: 100%; font-weight: normal" v-if="total1 != 0">
                <el-table-column header-align="center" align="center" prop="tag_name" label="Driver type" width="250px">
                </el-table-column>
                <el-table-column prop="worker_name" label="Drivers" show-overflow-tooltip>
                </el-table-column>
                <el-table-column label="Actions" width="130px">
                  <template slot-scope="scope">
                    <div class="action">
                      <span @click="handleEdit(scope.$index, scope.row)">
                        <img src="../assets/image/edit@2x.png" alt="" />
                      </span>
                      <span @click="handleDelete(scope.$index, scope.row)">
                        <img src="../assets/image/delete@2x.png" alt="" />
                      </span>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <div v-else class="empty">
                <div>
                  <img src="../assets/image/list_blank.png" alt="" />
                  <h2 style="color: #cccccc; font-size: 16px">
                    No items found
                  </h2>
                  <el-button type="primary" round style="margin-right: 16px" @click="addNew">NEW</el-button>
                </div>
              </div>
            </div>
            <div class="btomPagin">
              <div class="innerLefts">
                {{ page3 }} - <span>{{ TagsData.length }}</span> of
                <span>{{ total1 }}</span> items
              </div>
              <div>
                <el-pagination :page-size="10" layout="prev, pager, next, jumper" :total="total1"
                  @current-change="handleSizeChange2">
                </el-pagination>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div>
        <el-button round type="success" @click="updateAll" v-show="false">Update</el-button>
        <el-button type="primary" round style="margin-right: 16px" @click="addNew" v-if="showNew">NEW</el-button>
      </div>
    </div>
    <!--    add and edit groups-->
    <el-dialog :close-on-click-modal="false" style="padding-top: 0" :title="driverGroupTitle"
      :visible.sync="addDriverGroupDialog" width="40%">
      <div class="addInner">
        <el-form :model="addGroup" label-position="top" :rules="groupRules" status-icon ref="addGroups"
          :show-message="false">
          <el-form-item label="Driver Group Name" label-width="120px" prop="name">
            <el-input v-model="addGroup.name" placeholder="Name" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--    <el-button type="primary" plain >Cancel</el-button>-->
        <el-button type="danger" @click="
          addDriverGroupDialog = false;
        addGroup.name = '';
        " plain>Cancel</el-button>
        <el-button type="primary" round @click="confirmAdd">Save</el-button>
      </span>
    </el-dialog>
    <!--delete dialog-->
    <el-dialog :close-on-click-modal="false" style="padding-top: 0" :title="deleteTitle"
      :visible.sync="driverDeleteDialog" width="30%">
      <div class="addInner" v-if="driverDelete == 1" style="margin-top: 24px">
        {{ driverGroup }} will be permanently deleted. This gourp would not be
        used.
      </div>
      <div class="addInner" v-if="driverDelete == 2" style="margin-top: 24px">
        {{ drverName }} will be permanently deleted. This driver account will
        not be able to log in, but the data will remain.
      </div>
      <div class="addInner" v-if="driverDelete == 3" style="margin-top: 24px">
        The tag '{{ TagName }}' will be permanently deleted. This tag would not
        be used.
      </div>
      <div class="addInner" v-if="driverDelete == 4" style="margin-top: 24px">
        {{ active_name }} will be {{ active_status }}.This account would
        <span v-if="active_status == 'inactive'">not</span> be used.
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="driverDeleteDialog = false" plain>Cancel</el-button>
        <el-button type="primary" round @click="confirmDelete">
          <span v-if="driverDelete == 4">
            <span v-if="active_status == 'active'">Activate</span>
            <span v-else>Inactive</span>
          </span>
          <span v-else>Delete</span>
        </el-button>
      </span>
    </el-dialog>
    <!--    add drivers-->
    <el-dialog :close-on-click-modal="false" style="padding-top: 0" :title="driversTitle" :visible.sync="addDriverDialog"
      width="40%">
      <div class="addInner">
        <el-form :model="addDriver" label-position="top" :rules="driverRules" status-icon ref="addDriver" :show-message="false">
          
          <el-form-item label="Name" label-width="120px" prop="name">
            <el-input v-model="addDriver.name" placeholder="Name" autocomplete="off"></el-input>
          </el-form-item>
          
          <el-form-item label="Phone number(Unique ID)" label-width="120px" prop="phone" class="outBox">
            <el-input placeholder="Phone Number" v-model="addDriver.phone" class="input-with-select" :disabled="disabled">
              <el-select v-model="select" slot="prepend" placeholder="请选择" :disabled="disabled">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                  <div class="innerImg">
                    <span style="float: left">
                      <img src="../assets/image/canada.png" alt="" />
                      加拿大
                    </span>
                  </div>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{item.label}}</span>
                </el-option>
              </el-select>
            </el-input>
          </el-form-item>

          <el-form-item label="Driver code" label-width="120px" prop="codesabc">
            <el-input v-model="addDriver.codesabc" placeholder="Code" autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item label="Driver type" label-width="120px" prop="tags">
            <el-select v-model="addDriver.tags" placeholder="Select Driver type">
              <el-option v-for="item in tagsOptions" :key="item.id" :label="item.tag_name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Group" label-width="120px" prop="group">
            <el-select v-model="addDriver.group" placeholder="Select a group" multiple>
              <el-option v-for="item in groupOption" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--    <el-button type="primary" plain >Cancel</el-button>-->
        <el-button type="danger" @click="cancelAndClear" plain>Cancel</el-button>
        <el-button type="primary" round @click="confirmAddDriver">Save</el-button>
      </span>
    </el-dialog>
    <!-- add and edit tags -->
    <el-dialog :close-on-click-modal="false" style="padding-top: 0" :title="driverTagsTitle"
      :visible.sync="addDriverTagsDialog" width="40%">
      <div class="addInner">
        <el-form :model="addTags" label-position="top" :rules="tagsRules" status-icon ref="addTags" :show-message="false">
          <el-form-item label="Driver type" label-width="120px" prop="name">
            <el-input v-model="addTags.name" placeholder="Name" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--    <el-button type="primary" plain >Cancel</el-button>-->
        <el-button type="danger" @click="
          addDriverTagsDialog = false;
        addTags.name = '';
        " plain>Cancel</el-button>
        <el-button type="primary" round @click="confirmAddTags">Save</el-button>
      </span>
    </el-dialog>
    <!--    重置密码-->
    <el-dialog :close-on-click-modal="false" style="padding-top: 0" title="Reset Password" :visible.sync="resetDialog"
      width="30%">
      <div class="addInner">
        <el-form :model="resetPass" label-position="top" :rules="resetRules" ref="restForm" status-icon
          :show-message="false">
          <div>
            <el-form-item label="New Password" label-width="120px" prop="newPassword">
              <el-input v-model="resetPass.newPassword" placeholder="New Password" autocomplete="off">
              </el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="resetDialog = false" plain>Cancel</el-button>
        <el-button type="primary" round @click="saveRest">Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  addDrivers,
  addGroup,
  deleteDrivers,
  deleteGroup,
  editDrivers,
  editGroup,
  getDriversList,
  getGroupList,
  refreshDriver,
  workerTagList,
  workerTagAdd,
  workerTagEdit,
  workerTagDelete,
  changeDriverActive,
  resetDriverPas,
  printWorkerPDF
} from "@/api/driver";
// import drag_tree_handle from "./dispatch_test/drag_tree/drag_test copy.vue";

export default {
  name: "drivers",
  data() {
    return {
      resetPass: {
        newPassword: "",
      },
      resetRules: {
        newPassword: [{ required: true, message: "", trigger: "blur" }],
      },
      reset_driver: "",
      active_name: "",
      active_status: "",
      active_id: "",
      resetDialog: false,
      showNew: true, //用来控制显示top 的new按钮
      disabled: false,
      //电话区号
      options: [{ label: "+1", value: 1 }],
      select: 1, //电话区号
      driverLoading: false,
      groupId: "", //编辑group时的参数 id
      groupLoading: false, //分组列表loading
      groupTagsLoading: false,
      driversTitle: "Add a driver",
      addDriverDialog: false,
      addDriverGroupDialog: false,
      driverGroupTitle: "Create a driver group",
      activeNames: "first",
      driverGroup: "",
      driverDelete: "",
      deleteTitle: "",
      drverName: "",
      driverId: "",
      driverDeleteDialog: false,
      addGroup: {
        name: "",
      },
      addDriver: {
        name: "",
        phone: "",
        group: "",
        tags: "",
        codesabc: "",
      },
      driverRules: { 
        name: [{ required: true, message: "", trigger: "blur" }],
        phone: [{ required: true, message: "", trigger: "blur" }],
        // codesabc: [{ required: true, message: "", trigger: "blur" }],
      },
      groupRules: {
        name: [{ required: true, message: "", trigger: "blur" }],
      },
      tagsRules: {
        name: [{ required: true, message: "", trigger: "blur" }],
      },
      TagsData: [],
      driverData: [],
      page: 1,
      total: 3,
      groupData: [],
      page1: 1,
      total1: 0,
      groupOption: [],
      tagsOptions: [],
      driverTagsTitle: "Create a Driver type",
      addDriverTagsDialog: false,
      addTags: {
        name: "",
      },
      tagsId: "",
      TagName: "",
      page3: 1,

      nameInput: "",
      tagInput: "",
      groupInput: "",
      codeInput: "",

      isShowSearchBox: true,
    };
  },
  created() {
    //获取 dribers list
    this.getDriversListData();
    //drivers 时group下拉框
    getGroupList({
      page: 1,
      // limit:0
    }).then((res) => {
      this.groupOption = res.data.data;
    });
    //drivers 时tags下拉框
    this.getTagsListOptionData();
  },
  watch: {
    //监测编辑或者新增driver窗口关闭时清除数据
    addDriverDialog(val) {
      if (!val) {
        this.$refs["addDriver"].clearValidate();
        this.addDriver = {
          name: "",
          phone: "",
          group: "",
          tags: "",
          codesabc:"",
        };
      }
    },
    addDriverGroupDialog(val) {
      if (!val) {
        this.addGroup.name = "";
      }
    },
    addDriverTagsDialog(val) {
      if (!val) {
        this.addTags.name = "";
      }
    },
  },
  methods: {
    onclickDownloadPDF() {
      this.driverLoading = true;
      // console.log("--downloadpdf...");
      printWorkerPDF({
        page: this.page,
        limit: 10,
        name: this.nameInput,
        group_id: this.groupInput,
        tag_id: this.tagInput,
        code: this.codeInput,
      }).then(res=>{
        this.driverLoading = false;
        // console.log('---打印pdfres--',res)
        if (res.code == 200) {
          let baseUrl = process.env.VUE_APP_BASE_URL;
          let pdfurl = res.data.data
          // console.log( baseUrl + pdfurl)
          const newOpenWindow = window.open('about:blank')
          newOpenWindow.location = baseUrl + pdfurl
        }
      });
    },

    saveRest() {
      resetDriverPas({
        id: this.reset_driver,
        password: this.resetPass.newPassword,
      }).then((res) => {
        if (res.code == 200) {
          this.resetDialog = false;
          this.resetPass.newPassword = "";
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    activeAccount(row) {
      if (row.is_active == 0) {
        this.deleteTitle = "Activate the account";
        this.active_status = "active";
      } else {
        this.deleteTitle = "Inactivate the account";
        this.active_status = "inactive";
      }
      this.active_name = row.name;
      this.active_id = row.id;
      this.driverDelete = 4;
      this.driverDeleteDialog = true;
    },
    clearAll() {
      this.nameInput = "";
      this.tagInput = "";
      this.groupInput = "";
      this.getDriversListData();
    },

    getTagsListOptionData() {
      workerTagList({
        page: 1,
        // limit:0
      }).then((res) => {
        // this.tagsOptions.id = 0
        this.tagsOptions = res.data.data;
        this.tagsOptions.unshift({
          id: 0,
          tag_name: "No Driver type",
        });
      });
    },
    //切换导航栏标签分段器
    changeShowNew() {
      if (this.activeNames == "first") {
        this.getDriversListData();
        if (this.total == 0) {
          this.showNew = false;
        } else {
          this.showNew = true;
        }
        this.getTagsListOptionData();
        this.isShowSearchBox = true;
      } else if (this.activeNames == "second") {
        //获取group list
        this.getGroupListData();
        this.isShowSearchBox = false;
        // if (this.total1 == 0){
        //   this.showNew = false
        // }else {
        //   this.showNew = true
        // }
      } else if (this.activeNames == "third") {
        this.getGroupDriverTagsListData();
        this.isShowSearchBox = false;
      }
    },
    //标签司机分组新增和编辑
    confirmAddTags() {
      this.validateTagsForm();
      if (this.validateTagsForm()) {
        if (this.driverTagsTitle == "Create a Driver type") {
          workerTagAdd({
            tag_name: this.addTags.name,
          })
            .then((res) => {
              console.log("--resxinzeng--", res);
              if (res.code == 200) {
                this.$message({
                  message: res.msg,
                  type: "success",
                });
                this.getGroupDriverTagsListData();
                this.$refs["addTags"].resetFields();
                this.addDriverTagsDialog = false;
              } else {
                this.$message({
                  message: res.msg,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              this.$message({
                message: err.msg,
                type: "error",
              });
            });
        } else {
          workerTagEdit({
            tag_name: this.addTags.name,
            id: this.tagsId,
          })
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  message: res.msg,
                  type: "success",
                });
                this.getGroupDriverTagsListData();
                this.addTags.name = "";
                this.$refs["addTags"].clearValidate();
                this.addDriverTagsDialog = false;
              } else {
                this.$message({
                  message: res.msg,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              this.$message({
                message: err.msg,
                type: "error",
              });
            });
        }
      }
    },
    //获取标签司机分组的初始数据
    getGroupDriverTagsListData() {
      this.groupTagsLoading = true;
      workerTagList({
        page: this.page3,
        limit: 10,
      })
        .then((res) => {
          console.log("--res--", res);
          if (res.code == 200) {
            this.TagsData = res.data.data;
            this.total1 = res.data.count;
            this.groupTagsLoading = false;
            if (this.total1 == 0 && this.total == 0) {
              this.showNew = false;
            }
          } else {
            this.$message({
              message: res.mag,
              type: "warning",
            });
          }
        })
        .catch((err) => {
          this.$message({
            message: err.mag,
            type: "error",
          });
        });
    },

    //清空表单
    cancelAndClear() {
      this.$refs["addDriver"].clearValidate();
      this.addDriver = {
        name: "",
        phone: "",
        group: "",
        tags: "",
        codesabc:"",
      };
      this.addDriverDialog = false;
    },
    //新增 drivers 或编辑 drivers
    confirmAddDriver() {
      this.validateDriverForm();
      if (this.validateDriverForm()) {
        if (this.driversTitle == "Create a driver") {
          addDrivers({
            group_ids: this.addDriver.group,
            phone: this.addDriver.phone,
            phone_code: "1",
            name: this.addDriver.name,
            tag_id: this.addDriver.tags,
            code: this.addDriver.codesabc
          })
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  message: "Driver has been created",
                  type: "success",
                });
                this.addDriverDialog = false;
                this.getDriversListData();
              } else {
                this.$message({
                  message: res.msg,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              this.$message({
                message: err.msg,
                type: "error",
              });
            });
        } else {
          editDrivers({
            id: this.driverId,
            name: this.addDriver.name,
            phone: this.addDriver.phone,
            phone_code: "1",
            group_ids: this.addDriver.group,
            tag_id: this.addDriver.tags,
            code: this.addDriver.codesabc
          })
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  message: "Driver has been edited",
                  type: "success",
                });
                this.addDriverDialog = false;
                this.getDriversListData();
              } else {
                this.$message({
                  message: res.msg,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              this.$message({
                message: err.msg,
                type: "error",
              });
            });
        }
      } else {
        this.$message({
          type: "warning",
          message: "Some information missing",
        });
      }
    },
    getDriversListDataSearch() {
      this.page = 1;
      this.getDriversListData();
    },
    //获取drivers list
    getDriversListData() {
      this.driverLoading = true;
      getDriversList({
        page: this.page,
        limit: 10,
        name: this.nameInput,
        group_id: this.groupInput,
        tag_id: this.tagInput,
        code: this.codeInput,
      })
        .then((res) => {
          if (res.code == 200) {
            this.driverData = res.data.data;
            this.total = res.data.count;
            this.driverLoading = false;
            if (this.total1 == 0 && this.total == 0) {
              this.showNew = false;
            }
          } else {
            this.$message({
              message: res.mag,
              type: "warning",
            });
          }
        })
        .catch((err) => {
          this.$message({
            message: err.mag,
            type: "error",
          });
        });
    },
    //获取group list
    getGroupListData() {
      //获取group 列表
      this.groupLoading = true;
      getGroupList({
        page: this.page1,
        limit: 10,
      })
        .then((res) => {
          this.groupLoading = false;
          if (res.code == 200) {
            this.total1 = res.data.count;
            this.groupData = res.data.data;
            if (this.total1 == 0 && this.total == 0) {
              this.showNew = false;
            } else {
              this.showNew = true;
            }
          } else {
            this.$message({
              message: res.mag,
              type: "warning",
            });
          }
        })
        .catch((err) => {
          this.$message({
            message: err.mag,
            type: "error",
          });
        });
    },
    //group表单校验
    validateGroupForm() {
      let flag = false;
      this.$refs["addGroups"].validate((valid) => {
        flag = valid;
      });
      return flag;
    },
    //driver 表单校验
    validateDriverForm() {
      let flag = false;
      this.$refs["addDriver"].validate((valid) => {
        flag = valid;
      });
      return flag;
    },
    //tags 表单校验
    validateTagsForm() {
      let flag = false;
      this.$refs["addTags"].validate((valid) => {
        flag = valid;
      });
      return flag;
    },

    //新增 编辑 group
    confirmAdd() {
      this.validateGroupForm();
      if (this.validateGroupForm()) {
        if (this.driverGroupTitle == "Create a driver group") {
          addGroup({
            name: this.addGroup.name,
          })
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  message: "Driver group has been created",
                  type: "success",
                });
                this.getGroupListData();
                this.$refs["addGroups"].resetFields();
                this.addDriverGroupDialog = false;
              } else {
                this.$message({
                  message: res.msg,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              this.$message({
                message: err.msg,
                type: "error",
              });
            });
        } else {
          //编辑gropu
          editGroup({
            name: this.addGroup.name,
            id: this.groupId,
          })
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  message: res.msg,
                  type: "success",
                });
                this.getGroupListData();
                this.addGroup.name = "";
                this.$refs["addGroups"].clearValidate();
                this.addDriverGroupDialog = false;
              } else {
                this.$message({
                  message: res.msg,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              this.$message({
                message: err.msg,
                type: "error",
              });
            });
        }
      }
    },
    //刷新所有
    updateAll() {
      this.driverLoading = true;
      this.groupLoading = true;
      refreshDriver().then((res) => {
        if (res.code == 200) {
          this.getDriversListData();
          this.getGroupListData();
          this.$message({
            message: res.msg,
            type: "success",
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    addNew() {
      if (this.activeNames == "second") {
        this.driverGroupTitle = "Create a driver group";
        this.addDriverGroupDialog = true;
      } else if (this.activeNames == "first") {
        this.driversTitle = "Create a driver";
        this.disabled = false;
        this.addDriverDialog = true;
      } else if (this.activeNames == "third") {
        this.driverTagsTitle = "Create a Driver type";
        this.disabled = false;
        this.addDriverTagsDialog = true;
      }
    },
    handleEdit(index, row) {
      if (this.activeNames == "second") {
        this.driverGroupTitle = "Edit a driver group";
        this.addGroup.name = row.name;
        this.groupId = row.id;
        this.addDriverGroupDialog = true;
      } else if (this.activeNames == "first") {
        this.driversTitle = "Edit a driver";
        this.addDriverDialog = true;
        this.disabled = true;
        this.driverId = row.id;
        this.addDriver.name = row.name;
        this.addDriver.phone = row.phone;
        this.addDriver.group = row.group_id.map(Number);
        // this.addDriver.tags = row.tag_id.map(Number);
        this.addDriver.tags = parseInt(row.tag_id);
        this.addDriver.codesabc = row.code;

      } else if (this.activeNames == "third") {
        this.driverTagsTitle = "Edit a Driver type";
        this.addTags.name = row.tag_name;
        this.tagsId = row.id;
        this.addDriverTagsDialog = true;
        this.disabled = true;
      }
    },
    //删除
    handleDelete(index, row) {
      if (this.activeNames == "second") {
        this.deleteTitle = "Delete a driver group";
        this.driverDelete = 1;
        this.driverGroup = row.name;
        this.groupId = row.id;
        this.driverDeleteDialog = true;
      } else if (this.activeNames == "first") {
        this.deleteTitle = "Delete a driver";
        this.driverDelete = 2;
        this.drverName = row.name;
        this.driverId = row.id;
        this.driverDeleteDialog = true;
      } else if (this.activeNames == "third") {
        this.driverTagsTitle = "Delete a Driver type";
        this.driverDelete = 3;
        this.TagName = row.tag_name;
        this.tagsId = row.id;
        this.driverDeleteDialog = true;
      }
    },
    //确认删除
    confirmDelete() {
      if (this.driverDelete == 1) {
        //删除group
        deleteGroup({
          id: this.groupId,
        })
          .then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "Driver group has been deleted",
                type: "success",
              });
              this.getGroupListData();
              this.driverDeleteDialog = false;
            } else {
              this.$message({
                message: res.msg,
                type: "error",
              });
            }
          })
          .catch((err) => {
            this.$message({
              message: err.msg,
              type: "error",
            });
          });
      } else if (this.driverDelete == 2) {
        //删除 drivers
        deleteDrivers({
          id: this.driverId,
        })
          .then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "Driver has been deleted",
                type: "success",
              });
              this.getDriversListData();
              this.driverDeleteDialog = false;
            } else {
              this.$message({
                message: res.msg,
                type: "error",
              });
            }
          })
          .catch((err) => {
            this.$message({
              message: err.msg,
              type: "error",
            });
          });
      } else if (this.driverDelete == 3) {
        //删除 tags
        workerTagDelete({
          id: this.tagsId,
        })
          .then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "Tags has been deleted",
                type: "success",
              });
              this.getGroupDriverTagsListData();
              this.driverDeleteDialog = false;
            } else {
              this.$message({
                message: res.msg,
                type: "error",
              });
            }
          })
          .catch((err) => {
            this.$message({
              message: err.msg,
              type: "error",
            });
          });
      } else if (this.driverDelete == 4) {
        changeDriverActive({
          is_active: this.active_status == "active" ? 1 : 0,
          id: this.active_id,
        }).then((res) => {
          if (res.code == 200) {
            this.driverDeleteDialog = false;
            this.getDriversListData();
          }
        });
      }
    },
    //翻页
    handleSizeChange(val) {
      this.page = val;
      this.getDriversListData();
    },
    handleSizeChange1(val) {
      this.page1 = val;
      this.getGroupListData();
    },
    handleSizeChange2(val) {
      this.page3 = val;
      this.getGroupDriverTagsListData();
    },
  },
};
</script>

<style scoped lang="less">
.innerImg {
  display: inline-block;
  width: 300px;
  line-height: 30px;

  img {
    vertical-align: middle;
    margin-right: 8px;
  }
}

.driverMain {
  .topBton {
    /deep/.el-select-dropdown__list {
      width: 300px;
    }

    display: flex;
    justify-content: space-between;

    .innerLeft {
      // width: 288px;
      width: 432px;
      font-size: 14px;
      font-weight: 400;
      color: #1f2d42;
      height: 32px;
      line-height: 32px;
      border-radius: 16px;
      background: #ececf2;

      /deep/.el-tabs__content {
        width: calc(100vw - 248px);
      }

      /deep/ .el-tabs__nav-scroll {
        padding-left: 0;
      }

      /deep/ .el-tabs__nav-wrap::after {
        background: none;
      }

      /deep/ .el-tabs__item {
        height: 32px;
        line-height: 32px;
        flex: 1;
      }

      /deep/ .el-tabs__item.is-active {
        background: #e95646;
        color: #ffffff;
        border-radius: 16px;
      }

      /deep/.el-tabs__active-bar {
        background: none;
      }

      .paneOuts {
        text-align: center;
        padding-top: 200px;
      }

      .tabel {
        width: 100%;

        .action {
          span {
            cursor: pointer;
          }

          img {
            width: 16px;
            margin-right: 16px;
          }
        }

        /deep/.changePadding {
          padding-left: 48px;
        }
      }

      .btomPagin {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        padding-left: 16px;

        .innerLefts {
          font-size: 16px;
          font-family: SFPro-Regular, SFPro;
          font-weight: 400;
          color: #1f2d42;
          line-height: 20px;
        }
      }
    }
  }

  .addInner {
    //margin-top: 24px;
    font-weight: normal;
    font-size: 14px;
    color: #1f2d42;
    line-height: 20px;

    /deep/.el-input-group__prepend .el-select {
      margin: -10px 0;
    }

    /deep/ .el-input-group__prepend {
      padding: 0;
      width: 100px;
      background: none;
    }
  }

  .empty {
    width: 200px;
    height: 387px;
    margin: 20px auto;
    text-align: center;
    position: relative;

    div {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }

    h2 {
      font-size: 16px;
    }

    img {
      width: 100%;
      height: 200px;
      margin: 0;
    }
  }
}

.tasksTop {
  padding: 8px;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;

  /deep/.changeFocus:focus {
    border: 1px solid #dcdfe6;
    color: #606266;
  }

  .topSeach {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;

    /deep/ .el-input--prefix .el-input__inner {
      padding-left: 88px;
    }

    /deep/ .el-input__prefix {
      color: #1f2d42;
    }

    .long_search {
      /deep/.el-input__inner {
        padding-left: 115px !important;
      }
    }

    .long_searchs {
      /deep/.el-input__inner {
        padding-left: 133px !important;
      }
    }

    .innerSearch {
      margin: 8px;

      /deep/.el-cascader {
        line-height: 0;
      }

      .innerTime {
        /deep/.el-input__prefix {
          position: absolute;
          top: 0;
          right: 12px;
          left: auto;
        }

        /deep/ .el-input--prefix .el-input__inner {
          padding-left: 12px;
        }

        /deep/.el-input__icon {
          //position: absolute;
          //right: 12px;
          color: #d65953;
        }
      }

      .from {
        /deep/.el-input__inner {
          padding-left: 75px !important;
        }
      }

      .to {
        /deep/.el-input__inner {
          padding-left: 55px !important;
        }
      }
    }

    .cascader {
      position: relative;

      /deep/.el-input__inner {
        padding-left: 80px;
      }

      .slot {
        position: absolute;
        padding-left: 24px;
        font-size: 14px;
        top: 5px;
      }
    }

    .ex {
      // width: 300px;
      /deep/ .el-input--prefix .el-input__inner {
        padding-left: 120px;
      }
    }
  }
}
</style>
